/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import styled from 'styled-components';

import pxInRem from 'shared/helpers/styled-components/remHelper';
import { HOURS } from '../../constants';
import { FONT_FAMILIES } from 'shared/constants/theme';

const Wrapper = styled.div`
  width: calc(100% / ${HOURS.length});
  background-color: transparent;
  height: 40px;
  position: relative;
  display: inline-block;

  &:before {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    bottom: 0;
    width: 1px;
    background-color: white;
  }
`;

const Label = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  color: ${props => props.theme.tvGuide.hours.color};
  font-family: ${FONT_FAMILIES.base};
  font-size: ${pxInRem('11px')};
  height: 100%;
  margin-left: ${pxInRem('10px')};
`;

// eslint-disable-next-line react/prefer-stateless-function
class Hour extends React.PureComponent {
  render() {
    const { label, className } = this.props;
    return (
      <Wrapper className={className}>
        <Label>{label}</Label>
      </Wrapper>
    );
  }
}

Hour.displayName = 'Hour';

export default Hour;
